import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-32 md:py-40 px-6 bg-primary text-white text-center relative overflow-hidden" data-id="element-34">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/food.png')] opacity-10 mix-blend-overlay" data-id="element-35"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-37">
          <h2 className="text-5xl md:text-7xl font-serif font-black mb-8 leading-tight tracking-tight" data-id="element-38">
            VOLVÉ A DISFRUTAR LAS COMIDAS QUE MÁS TE GUSTAN
          </h2>
          <p className="text-2xl md:text-3xl text-green-50 mb-16 max-w-3xl mx-auto font-medium" data-id="element-39">
            No esperes más para transformar tu alimentación sin resignar el
            sabor.
          </p>

          <Button className="bg-white text-primary hover:bg-gray-50 shadow-2xl shadow-black/20" data-id="element-40">
            QUIERO VOLVER A DISFRUTAR LA COMIDA
          </Button>
        </motion.div>
      </div>
    </section>;
}